<template>
    <search-autocomplete
        v-model="wrapValue"
        :label="(item) => (item.id + ' ' + item.user.name)"
        :value-key="valueKey"
        state-name="pages/masters"
        v-bind="$attrs"
        @focus="$emit('focus', $event)"
        :search-method="masterSearch">
        <template v-slot="props">
            {{ props.item.id  + ' ' + props.item.user.name }}
        </template>
    </search-autocomplete>
</template>

<script>
import { mapActions } from 'vuex';
import SearchAutocomplete from "../SearchAutocomplete";

export default {
    name: "SearchMaster",
    components: {SearchAutocomplete},
    props: {
        value: {
            requested: true,
            default: () => ''
        },
        valueKey: {
            type: String,
            default: 'user_id'
        }
    },
    data: () => ({
        wrapValue: '',
    }),
    watch: {
        value(val) {
            this.$set(this, 'wrapValue', val);
        },
        wrapValue(val) {
            this.$emit('input', val);
        }
    },
    methods: {
        ...mapActions('pages', [
            'masterSearch'
        ])
    },
    mounted() {
        this.$set(this, 'wrapValue', this.value);
    }
}
</script>